<script>
  import gql from 'graphql-tag'

  export default {
    props: ['gid'],
    apollo: {
      requireAmountConfirmation: {
        fetchPolicy: "no-cache",
        query: gql`query($gid: ID) {
          merchant(gid: $gid) { merchantUser {settings {payaSettings {requireAmountConfirmation}}}}
        }`,
        variables() {
          return {
            gid: this.gid
          }
        },
        update: data => data.merchant.merchantUser.settings.payaSettings.requireAmountConfirmation
      }
    },
    data() {
      return {
        requireAmountConfirmation: null
      }
    },
    methods: {
      switchSetting() {
        this.$apollo.mutate({
          mutation: gql`mutation ($requireAmountConfirmation: Boolean!, $gid: ID) {
            updatePayaSettings(input: {settings: {requireAmountConfirmation: $requireAmountConfirmation}, userId: $gid}) {
              payaSettings {
                requireAmountConfirmation
              }
              errors
            }
          }`,
          variables: {
            requireAmountConfirmation: this.requireAmountConfirmation,
            gid: this.gid
          },
        }).then(result => {
          if (result.data.updatePayaSettings.errors.length > 0) {
            this.notifyError(result.data.updatePayaSettings.errors[0])
            this.$apollo.queries.requireAmountConfirmation.refetch()
          } else {
            this.notifySuccess("Settings successfully updated")
          }
        }, error => {
          this.$apollo.queries.requireAmountConfirmation.refetch()
          this.gqlErrorHandler(error)
        })
      }
    }
  }
</script>

<template>
  <div>
    <section>
      <div class= "very-close-lines">
        Require amount confirmation for checks:<br>
        <small class="grey-text">Show popup to retype amount when processing checks</small>
      </div>
      <!-- Switch -->
      <div class="switch mt-5">
        <label>
          Off
          <input type="checkbox" @change='switchSetting' v-model='requireAmountConfirmation' :disabled="$apollo.loading">
          <span class="lever"></span>
          On
        </label>
      </div>
    </section>
  </div>
</template>